module.exports = __webpack_public_path__ + "static/media/profStats.7004be25.png";